import {AxiosRequestConfig, AxiosResponse} from 'axios'
import {ExceptionError} from '../exception'
import {Request} from '../request'
import {IBulkPlantCreate, IPlant, IPlantCreate, IPlantUpdate} from '../../interface/plant/plant'
import {IPageOption} from '../../interface/paging/paging'
import {
  IApiResponse,
  IApiListResponse,
  IBulkTemplateResponse,
} from '../../interface/api-response/api-response'
import {API_PATH} from '../../constants/api-path'

export class GetPlantService extends Request {
  async request(options?: IPageOption) {
    try {
      const {data} = await this.client
        .get<IApiListResponse<IPlant[]>>(API_PATH.PLANT, {
          params: options,
        })
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class CreatePlantService extends Request {
  async request(payload: IPlantCreate) {
    const {data} = await this.client.post<IPlant>(API_PATH.PLANT, payload)
    try {
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class UpdatePlantService extends Request {
  async request(payload: IPlantUpdate) {
    try {
      const {data} = await this.client.patch<IPlant>(API_PATH.PLANT, payload)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class DeletePlantService extends Request {
  async request(id: string) {
    try {
      const {data} = await this.client
        .delete<IApiResponse<any>>(`${API_PATH.PLANT}/${id}`, {})
        .then((d) => d.data)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetPlantByCompanyService extends Request {
  async request(id: string) {
    try {
      const {data} = await this.client
        .get<IApiResponse<IPlant[]>>(`${API_PATH.PLANT}/get-by-company-id/${id}`, {
          params: {getOnlyActive: true},
        })
        .then((d) => d.data)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

class GetBulkPlantTemplate extends Request {
  async request(companyIds: string[]) {
    try {
      const {data} = await this.client
        .get<IApiResponse<IBulkTemplateResponse>>(`${API_PATH.PLANT}/bulk-plant`, {
          params: {companyIds},
        })
        .then((d) => d.data.data)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetPlantLogService extends Request {
  async request(params: any) {
    try {
      const {data} = await this.client
        .get<IApiResponse<any>>(`${API_PATH.PLANT}/get-log/${params.id}`, {params})
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

class CreateBulkPlant extends Request {
  async request(payload: IBulkPlantCreate) {
    try {
      await this.client.post(`${API_PATH.PLANT}/bulk-plant`, payload)
    } catch (error: any) {
      const errMsg: any = !error.response.data?.errors
        ? error.response.data.message
        : `<div style="text-align: left;">${error.response.data.errors
            .map((e) => `<li>${e}</li>`)
            .join('')}</div>`

      throw new ExceptionError({message: errMsg} as any)
    }
  }
}

export class UploadBulkPlant extends Request {
  async request(payload: any) {
    try {
      await this.client.post(`${API_PATH.PLANT}/bulk-plant/file`, payload)
    } catch (error: any) {
      const errMsg: any = !error.response.data?.errors
        ? error.response.data.message
        : `<div style="text-align: left;">${error.response.data.errors
            .map((e) => `<li>${e}</li>`)
            .join('')}</div>`

      throw new ExceptionError({message: errMsg} as any)
    }
  }
}

export class GetPlantHistoryBulkService extends Request {
  async request(params: any) {
    try {
      const {data} = await this.client
        .get<IApiResponse<any>>(`${API_PATH.PLANT}/bulk-tag/file`, {params})
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class DownloadPlantHistoryBulkService extends Request {
  async request(id: string) {
    try {
      const {data} = await this.client
        .get<any>(`${API_PATH.PLANT}/bulk-tag/file/${id}`, {
          responseType: 'blob', // Important: set response type to blob
        })
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export const uploadBulkPlant = new UploadBulkPlant()
export const createBulkPlant = new CreateBulkPlant()
export const getBulkPlantTemplate = new GetBulkPlantTemplate()
